document.addEventListener("DOMContentLoaded", function () {
  // Function to update the navigation height and set CSS variables
  function updateNavigationHeight() {
    const nav = document.querySelector(".navbar");
    const navigationHeight = nav ? nav.offsetHeight : 0;
    /*     console.log(navigationHeight);
     */ document.documentElement.style.setProperty(
      "--top-margin",
      `${navigationHeight}px`
    );
  }

  // Initial call to set the values on page load
  updateNavigationHeight();

  // Update values on window resize
  window.addEventListener("resize", updateNavigationHeight);
});
